import script from "./MindCollect.vue?vue&type=script&setup=true&lang=js"
export * from "./MindCollect.vue?vue&type=script&setup=true&lang=js"

import "./MindCollect.vue?vue&type=style&index=0&id=bca5b43c&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bca5b43c"]])

export default __exports__